export const removeHtmlTags = (str: string | undefined): string => {
    if (!str) return '';
    return str.replace(/<\/?[^>]+(>|$)/g, '').trim();
};
